const COLUMNS = [
  { label: 'date', className: 'align-left' },
  { label: 'request', className: 'align-left' },
  { label: 'response', className: 'align-left' },
  { label: 'details', className: 'align-center log-details' },
  { label: 'download', className: 'align-center log-download' },
]

export { COLUMNS }
